import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import NumberRangeOverviewPanel from "../components/NumberRangeOverviewPanel";

export default function EventCodeRangesPage() {
  const theme = useTheme();

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, color: theme.palette.text.primary }}>
          Event code functions
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1, maxWidth: 720 }}>
          Visual map of base and sub functions with event code ranges. Look up a rising code to find its
          function, or browse tiles by base digit.
        </Typography>
      </Box>
      <NumberRangeOverviewPanel />
    </Container>
  );
}
